export const MEDIA_CONSTANTS = {
  DEFAULT_TAKE: 100,
};

export const MEDIAGALLERY_CONSTANTS = {
  DEFAULT_TAKE: 10,
  DEFAULT_SKIP: 0,
  DEFAULT_PAGE: 1,
};
